<template>
    <div>
        <Navbar />
        <BuyNow />
        <PageTitle pageTitle="Blog Yazılarımız" />
        <Courses pathUrl="https://dryyazilim.com.tr/anaokulu/assets/data/get.php" />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import Courses from '../Blogs/BlogList'
import Footer from '../Layouts/Footer'
import BuyNow from '../Layouts/BuyNow'

export default {
    name: 'CoursesPageTwo',
    components: {
    Navbar,
    PageTitle,
    Courses,
    Footer,
    BuyNow
},
}
</script>